import axios from 'axios';

const BASE_URL = 'https://api.luvutech.com';

function formatAuthToken(token) {
  if (!token) {
    return '';
  }

  return token.startsWith('Bearer ') ? token : `Bearer ${token}`;
}

function isSuccessCode(code) {
  return code === undefined || code === 0 || code === 200;
}

export function createRequestClient(options = {}) {
  const {
    tokenProvider = () => '',
    onUnauthorized = () => {}
  } = options;

  const client = axios.create({
    baseURL: BASE_URL,
    timeout: 15000
  });

  client.interceptors.request.use(config => {
    const nextConfig = {
      ...config,
      headers: {
        Accept: 'application/json',
        Trans: 'cn',
        ...(config.headers || {})
      }
    };
    const token = tokenProvider();

    if (token) {
      nextConfig.headers.Authorization = formatAuthToken(token);
    }

    return nextConfig;
  });

  client.interceptors.response.use(
    response => {
      if (response.config && response.config.responseType === 'blob') {
        return Promise.resolve(response.data);
      }

      const payload = response.data;

      if (payload && payload.code === 401) {
        onUnauthorized(payload);
        // new Error(payload.message || '登录失效，请重新登录')
        return Promise.reject(null);
      }

      if (!isSuccessCode(payload.code)) {
        return Promise.reject(new Error(payload.message || '请求失败'));
      }

      return Promise.resolve(payload);
    },
    error => {
      if (error && error.response && error.response.status === 401) {
        onUnauthorized(error);
      }

      return Promise.reject(
        new Error(
          error &&
            error.response &&
            error.response.data &&
            error.response.data.message
            ? error.response.data.message
            : error.message || '网络异常'
        )
      );
    }
  );

  return client;
}
